import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { CLIENT_LOGOS } from '@/lib/constants';

const trustMetrics = [
  { value: 739, suffix: '+', label: 'Organisations' },
  { value: 500000, suffix: '+', label: 'Lives Impacted', format: true },
  { value: 18, suffix: '+', label: 'Years' },
  { value: 96.4, suffix: '%', label: 'Satisfaction', decimals: 1 },
];

export const TrustBar = () => {
  const { ref, inView } = useInView({ threshold: 0.3, triggerOnce: true });

  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...CLIENT_LOGOS, ...CLIENT_LOGOS, ...CLIENT_LOGOS];

  return (
    <div
      ref={ref}
      className="bg-[#1A1008] py-5 relative overflow-hidden"
      data-testid="trust-bar"
    >
      {/* Metrics Section */}
      <div className="mx-auto w-full max-w-[1400px] px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between gap-8 overflow-x-auto no-scrollbar">
          <span className="text-white/30 text-[12px] font-medium tracking-[0.1em] uppercase whitespace-nowrap hidden md:block">
            Trusted by India's leading organisations
          </span>
          <div className="flex items-center gap-8 sm:gap-12 mx-auto md:mx-0">
            {trustMetrics.map((metric, i) => (
              <div key={i} className="flex items-center gap-2.5 whitespace-nowrap">
                <span className="text-white font-bold text-lg tracking-tight" data-testid="metrics-countup-value">
                  {inView ? (
                    <CountUp
                      end={metric.value}
                      duration={2}
                      decimals={metric.decimals || 0}
                      separator={metric.format ? ',' : ''}
                      suffix={metric.suffix}
                    />
                  ) : '0'}
                </span>
                <span className="text-white/30 text-[11px] tracking-wide">{metric.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Logo Scroll Section */}
      <div className="mt-6 relative overflow-hidden">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#1A1008] to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#1A1008] to-transparent z-10" />
        
        <div 
          className="flex gap-12 animate-scroll whitespace-nowrap"
          data-testid="client-logos-scroll"
        >
          {duplicatedLogos.map((logo, index) => (
            <div
              key={`${logo.name}-${index}`}
              className="flex items-center justify-center flex-shrink-0 w-28 h-12"
              data-testid={`client-logo-${logo.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <img
                src={logo.url}
                alt={logo.alt}
                className="max-w-full max-h-full w-auto h-auto object-contain grayscale brightness-[2] opacity-60 hover:opacity-90 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default TrustBar;
